import Joi from 'joi';

const schema = {
  sort: Joi.string().default('name-asc'),
  skip: Joi.number().default(0),
  limit: Joi.number().default(25),
  id: Joi.array().items(Joi.number()),
  query: Joi.string().allow(null, '').default(''),
};

export default schema;
